export default __webpack_public_path__ + "static/media/img1.80d19213.PNG";